import React, { useEffect, useState } from "react";
import {
  Chart as ChartJs,
  ArcElement,
  Tooltip,
  Legend,
  LinearScale,
} from "chart.js";
import datalabels from "chartjs-plugin-datalabels";
import { Doughnut } from "react-chartjs-2";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import "./maintaince.css";

ChartJs.register(ArcElement, Tooltip, Legend, LinearScale);
ChartJs.register(datalabels);

const statusOrder = [
  "طلبات جديده",
  "الطلبات التي تم الموافقه عليها",
  "الطلبات المرفوضه",
  "المواعيد التي تم جدولتها",
  "الطلبات التي تم تنفيذها",
  "المواعيد التي تم إلغائها",
];

const getStatusColor = (statusValue) => {
  switch (statusValue) {
    case "طلبات جديده":
      return "#FFA500";
    case "الطلبات التي تم الموافقه عليها":
      return "#9966FF";
    case "الطلبات المرفوضه":
      return "#8280FF";
    case "المواعيد التي تم جدولتها":
      return "#00B69B";
    case "الطلبات التي تم تنفيذها":
      return "#3B82F6";
    case "المواعيد التي تم إلغائها":
      return "#FF587C";
    default:
      return "#FFCD56";
  }
};

const MaintainceState = () => {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  const baseUrl =
    "https://api.generalhome.sa/api/Reports/GetStatusRequests";

  useEffect(() => {
    const fetchInfo = async () => {
      try {
        const maintenanceAreaIdsString =
          localStorage.getItem("MaintenanceAreaIds");
        const maintainceAreaId = maintenanceAreaIdsString
          ? maintenanceAreaIdsString.split(",").map(Number)
          : [];
        const response = await axios.post(
          baseUrl,
          {
            maintenanceAreaIds: maintainceAreaId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        );

        const result = statusOrder.map((status) => {
          const found = response.data.find((x) => x.StatusValue === status);
          return {
            StatusValue: status,
            RequestCount: found ? found.RequestCount : 0,
          };
        });

        setChartData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchInfo();
  }, []);

  const prepareChartData = () => {
    const labels = chartData.map((x) => x.StatusValue);
    const dataValues = chartData.map((x) => x.RequestCount);
    const backgroundColors = chartData.map((x) =>
      getStatusColor(x.StatusValue)
    );

    return {
      labels,
      datasets: [
        {
          label: "حاله الصيانه",
          data: dataValues,
          backgroundColor: backgroundColors,
          borderWidth: 2,
          borderColor: "#fff",
        },
      ],
    };
  };

  const data = prepareChartData();

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: "70%",
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        callbacks: {
          label: function (context) {
            return `${context.label}: ${context.raw}`;
          },
        },
      },
      datalabels: { display: false },
    },
  };

  const centerTextPlugin = {
    id: "centerText",
    beforeDraw(chart) {
      const { ctx, chartArea } = chart;
      if (!chartArea) return;

      const centerX = (chartArea.left + chartArea.right) / 2;
      const centerY = (chartArea.top + chartArea.bottom) / 2;

      const total = chart.data.datasets[0].data.reduce(
        (acc, val) => acc + val,
        0
      );

      ctx.save();

      ctx.fillStyle = "#444";
      ctx.font = "bold 14px Cairo";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText("إجمالي الطلبات", centerX, centerY - 10);
      ctx.font = "bold 14px Arial";
      ctx.fillText(total.toString(), centerX, centerY + 15);

      ctx.restore();
    },
  };

  if (loading) {
    return (
      <div className="loading-container">
        <ClipLoader color="#00b1ff" size={50} />
      </div>
    );
  }

  return (
    <div className="maintainceChart">
      <div className="maintainceChart-container">
        <div className="chart-title">
          <h4>حالة الطلبات</h4>
          <input
            type="month"
            id="month"
            name="month"
            value="2025-01"
            className="month-picker"
          />
        </div>
        <div className="parent-box">
          {/* Legend */}
          <div className="legend-box">
            <div className="legend-items">
              {chartData.map((status, i) => (
                <div className="legend-item" key={i}>
                  <div className="legend-info">
                    <span
                      className={`color-indicator status-${status.StatusValue.replace(
                        /\s+/g,
                        "-"
                      ).toLowerCase()}`}
                    ></span>
                    <h5>{status.StatusValue}</h5>
                  </div>
                  <h6>{status.RequestCount}</h6>
                </div>
              ))}
            </div>
          </div>
          {/* Doughnut Chart */}
          <div className="chart-container">
            <Doughnut
              data={data}
              options={options}
              plugins={[centerTextPlugin]}
              height={200}
              width={200}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintainceState;
